import { render, staticRenderFns } from "./CharCounter.vue?vue&type=template&id=763c8e2d&"
import script from "./CharCounter.vue?vue&type=script&lang=js&"
export * from "./CharCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports